import { createSlice } from '@reduxjs/toolkit';
import { regionApi, regionInstanceApi } from '../services';
import { RootState } from './index';
import { MY_ACCOUNT_LIST } from '../utils/helper';

interface IAccount {
  instances: Record<string, any>;
  rejectedInstances: Record<string, any>;
}

const initialState: IAccount = {
  instances: { [MY_ACCOUNT_LIST]: {} },
  rejectedInstances: { [MY_ACCOUNT_LIST]: {} }
};

const instanceExtraSlice = createSlice({
  name: 'instanceExtraInfo',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      regionApi.endpoints.regionLogin.matchFulfilled,
      (state, { payload }) => {
        const region: Record<string, any> = payload || {};
        if (region?.groups) {
          region?.groups.flat(1).forEach((obj: Record<string, any>) => {
            if (obj?.id) {
              state.instances[obj?.id] = state.instances[obj?.id] || {};
            }
          });
        }
      }
    );
    builder.addMatcher(
      regionInstanceApi.endpoints.getInstanceExtraInfo.matchFulfilled,
      (state, { payload, meta }) => {
        const { arg } = meta;
        const account_id = arg?.originalArgs?.account?.account_id;
        const group_id =
          arg?.originalArgs?.account?.group_id || MY_ACCOUNT_LIST;
        if (account_id) {
          const group = state.instances[group_id] || {};
          state.instances[group_id] = {
            ...group,
            [account_id]: {
              ...payload,
              is_active: payload?.is_active === false ? false : true,
              requestStatus: 'fulfilled'
            }
          };
          if (state.rejectedInstances[group_id]?.[account_id]) {
            const newGroupObj = { ...state.rejectedInstances[group_id] };
            delete newGroupObj[account_id];
            state.rejectedInstances[group_id] = newGroupObj;
          }
        }
      }
    );

    builder.addMatcher(
      regionInstanceApi.endpoints.getInstanceExtraInfo.matchRejected,
      (state, { error, meta, payload }) => {
        console.warn(
          '----------- get_instance_info rejected',
          meta,
          payload,
          error
        );
        const account_id = meta?.arg?.originalArgs?.account?.account_id || '';
        const group_id =
          meta?.arg?.originalArgs?.account?.group_id || MY_ACCOUNT_LIST;
        if (account_id) {
          state.rejectedInstances[group_id] =
            state.rejectedInstances[group_id] || {};
          state.rejectedInstances[group_id][account_id] = {
            ...meta?.arg?.originalArgs,
            error: error,
            payload: payload
          };
        }
      }
    );
    builder.addMatcher(
      regionInstanceApi.endpoints.getInstanceExtraInfo.matchPending,
      (state, { meta }) => {
        const { arg } = meta;
        const account_id = arg?.originalArgs?.account?.account_id;
        const group_id =
          arg?.originalArgs?.account?.group_id || MY_ACCOUNT_LIST;
        if (account_id) {
          const group = state.instances[group_id] || {};
          const account = group[account_id];
          if (account?.requestStatus !== 'fulfilled') {
            state.instances[group_id] = {
              ...group,
              [account_id]: {
                requestStatus: 'pending'
              }
            };
          }
        }
      }
    );
  }
});

const { reducer, actions } = instanceExtraSlice;

export const selectInstancesExtraInfo = (state: RootState) =>
  state.instanceExtra?.instances;
export const selectRejectedInstances = (state: RootState) =>
  state.instanceExtra?.rejectedInstances;
export default reducer;
